export const ENVIRONMENTS = {
  DEV: "dev",
  QA: "qa",
  PROD: "prod",
  LOCAL: "local",
} as const;

type Environment = (typeof ENVIRONMENTS)[keyof typeof ENVIRONMENTS];

export const ENVIRONMENT: Environment = ENVIRONMENTS.LOCAL as Environment;

const protocol = ENVIRONMENT === ENVIRONMENTS.LOCAL ? "http" : "https";

export const PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=com.auxwit.drivemynt';
export const APPSTORE_URL = 'https://apps.apple.com/in/app/drivemynt/id6761471510';

const baseUrls :any = {
  local: "localhost:8080",
  dev: "as-dsms-webapi-dev.azurewebsites.net",
  prod: "drivemyntapi.azurewebsites.net"
};


const env = {
  apiUrl: `${protocol}://${baseUrls[ENVIRONMENT]}/api/v1`,
  authUrl: `${protocol}://${baseUrls[ENVIRONMENT]}/auth`,
  razorPayKey: "rzp_test_SKHGPn6pH5uFoG",
  plan_pro: "plan_SL8hJKdRsuajgG",
  customRazorpayLink: "https://rzp.io/rzp/NDAseu1",
};

export default env;